"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function TransparentOrigins() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  return <section data-section-id="232056" id="policy-overview" className="bg-background text-foreground relative w-full overflow-hidden" style={{
    minHeight: "100svh"
  }}>
      {}
      <div className="absolute inset-0 w-full h-full">
        <video className="w-full h-full object-cover" autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663456/img/privacy_security_poster.png">
          <source src="/img/data_protection_video.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0" style={{
        backgroundColor: "rgba(255,255,255,0.40)"
      }} />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 py-24 text-center">
        <div ref={textRef} className={`transition-all duration-1000 ease-out ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <p className="font-default text-xs tracking-widest uppercase mb-6 text-primary font-semibold">
            Legal &mdash; Data Protection
          </p>

          {}
          <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl leading-tight tracking-tighter text-foreground mb-8" style={{
          fontFamily: "var(--font-serif)"
        }}>
            Our Privacy
            <br />
            Policy
          </h1>

          {}
          <p className="font-default text-base sm:text-lg md:text-xl text-muted-foreground max-w-xl mx-auto mb-10 leading-relaxed">
            We are committed to protecting your personal information and your right to privacy. 
            Learn how we handle your data with the utmost care and transparency.
          </p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 py-3 text-sm tracking-widest uppercase font-default font-medium shadow-md">
              <Link to="/PrivacyPolicyPage">Read Full Policy</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-primary/50 text-primary bg-white/50 backdrop-blur-sm hover:bg-accent rounded-md px-8 py-3 text-sm tracking-widest uppercase font-default font-medium shadow-sm">
              <Link to="/CookiePolicyPage">Cookie Settings</Link>
            </Button>
          </div>
        </div>

        {}
        <div className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-1000 delay-700 ${textVisible ? "opacity-100" : "opacity-0"}`}>
          <span className="text-muted-foreground text-xs tracking-widest uppercase font-default">Scroll</span>
          <div className="w-px h-10 bg-primary/30 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full bg-primary" style={{
            height: "40%",
            animation: "scrollIndicator 1.8s ease-in-out infinite"
          }} />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollIndicator {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(300%); }
        }
      `}</style>
    </section>;
}